import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Check if we have access to the new createRoot API (React 18+)
let ReactDOM;
try {
  ReactDOM = require('react-dom/client');
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
} catch (e) {
  // Fallback for React 17 and older
  ReactDOM = require('react-dom');
  ReactDOM.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
  );
}